export interface ParsedBlock {
  title: string;
  body: string;
}

export const parseToJson = (text: string): ParsedBlock => {
  if (!text || typeof text !== "string") {
    return { title: "", body: "" };
  }

  // Ищем первую строку, начинающуюся с "#"
  const match = text.match(/^(?:#{1,2}\s*)?(.+)$/m);

  if (!match) {
    return {
      title: "",
      body: text.trim(),
    };
  }

  const title = match[1].trim();
  const body = text.slice(match.index! + match[0].length).trim();

  return { title, body };
};

export const groupSections = (sections: string[]) => {
  const g1 = []; // < 3
  const g2 = []; // 3–5
  const g3 = []; // > 5

  // Собираем номера всех секций
  const numbers = sections.map(sec => {
    const m = sec.match(/^(?:#{1,2}\s*)?(\d+)\./m);
    return m ? Number(m[1]) : null;
  });

  // Находим индекс первого пронумерованного пункта
  const firstNumberIndex = numbers.findIndex(n => n !== null);

  for (let i = 0; i < sections.length; i++) {
    const sec = sections[i];
    const num = numbers[i];

    if (num !== null) {
      // Пронумерованная секция
      if (num < 3) g1.push(parseToJson(sec));
      else if (num >= 3 && num < 5) g2.push(parseToJson(sec));
      else g3.push(parseToJson(sec));
    } else {
      // Ненумерованная секция
      if (i < firstNumberIndex) {
        // До первого номера → группа 1
        g1.push(parseToJson(sec));
        continue;
      }

      // Ищем ближайший следующий номер
      let nextNum = null;
      for (let j = i + 1; j < numbers.length; j++) {
        if (numbers[j] !== null) {
          nextNum = numbers[j];
          break;
        }
      }

      if (nextNum === null) {
        // Нет следующего номера → группа 3
        g3.push(parseToJson(sec));
      } else if (nextNum < 3) {
        g1.push(parseToJson(sec));
      } else if (nextNum >= 3 && nextNum <= 5) {
        g2.push(parseToJson(sec));
      } else {
        g3.push(parseToJson(sec));
      }
    }
  }

  return { g1, g2, g3 };
}
